import { ChainCallProtocolTabs } from '../ChainCallProtocolTabs';
import { ChainSubtypeTabs } from '../ChainSubtypeTabs';
import { ChainTypeTabs } from '../ChainTypeTabs';
import { ConsensusSwitch } from '../ConsensusSwitch';
import { GroupSelector } from '../GroupSelector';
import { useChainSelectorsStyles } from './useChainSelectorsStyles';

interface ChainSelectorsProps {
  canChainTypeTabBeBlocked?: boolean;
  className?: string;
  onBlockedChainTypeTabClick?: () => void;
}

export const ChainSelectors = ({
  canChainTypeTabBeBlocked,
  className,
  onBlockedChainTypeTabClick,
}: ChainSelectorsProps) => {
  const { classes, cx } = useChainSelectorsStyles();

  return (
    <div className={cx(classes.root, className)}>
      <ChainTypeTabs
        canTabBeBlocked={canChainTypeTabBeBlocked}
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
        onBlockedTabClick={onBlockedChainTypeTabClick}
      />
      <ChainSubtypeTabs
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
      <GroupSelector />
      <ChainCallProtocolTabs
        classNameTab={classes.tab}
        classNameTabsInner={classes.tabsInner}
        classNameTabsWrapper={classes.tabsWrapper}
      />
      <ConsensusSwitch />
    </div>
  );
};
